import { render, staticRenderFns } from "./GuestRegistrationCard.vue?vue&type=template&id=1c18b98c&scoped=true"
import script from "./GuestRegistrationCard.vue?vue&type=script&lang=js"
export * from "./GuestRegistrationCard.vue?vue&type=script&lang=js"
import style0 from "./GuestRegistrationCard.vue?vue&type=style&index=0&id=1c18b98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18b98c",
  null
  
)

export default component.exports